<!-- Create Records Download Request - M3 Design -->
<div class="main_body">
  <app-page-header
    title="新規ダウンロードリクエスト"
    i18n-title="@@adminSection.createRecordsDownloadRequest.title.page"
    [backLabel]="i18n.nav.backToList"
    backIcon="cloud_download"
    [useHistoryBack]="true"
    icon="download"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="stepper-container">
          <!-- Sidebar Navigation -->
          <nav class="stepper-sidebar" aria-label="ステップナビゲーション">
            <button type="button"
                    class="stepper-sidebar__step"
                    [class.stepper-sidebar__step--active]="currentStepIndex === 0"
                    [class.stepper-sidebar__step--completed]="currentStepIndex > 0"
                    (click)="goToStep(0)"
                    [disabled]="currentStepIndex < 0">
              <span class="stepper-sidebar__num" [class.stepper-sidebar__num--active]="currentStepIndex === 0" [class.stepper-sidebar__num--completed]="currentStepIndex > 0">1</span>
              <span class="stepper-sidebar__label" i18n="@@adminSection.createRecordsDownloadRequest.step.conditions">抽出条件を指定</span>
            </button>
            <button type="button"
                    class="stepper-sidebar__step"
                    [class.stepper-sidebar__step--active]="currentStepIndex === 1"
                    [class.stepper-sidebar__step--completed]="currentStepIndex > 1"
                    (click)="goToStep(1)"
                    [disabled]="currentStepIndex < 1">
              <span class="stepper-sidebar__num" [class.stepper-sidebar__num--active]="currentStepIndex === 1" [class.stepper-sidebar__num--completed]="currentStepIndex > 1">2</span>
              <span class="stepper-sidebar__label" i18n="@@adminSection.createRecordsDownloadRequest.step.sizeEstimation">サイズ見積もり</span>
            </button>
            <button type="button"
                    class="stepper-sidebar__step"
                    [class.stepper-sidebar__step--active]="currentStepIndex === 2"
                    [class.stepper-sidebar__step--completed]="currentStepIndex > 2"
                    (click)="goToStep(2)"
                    [disabled]="currentStepIndex < 2">
              <span class="stepper-sidebar__num" [class.stepper-sidebar__num--active]="currentStepIndex === 2">3</span>
              <span class="stepper-sidebar__label" i18n="@@adminSection.createRecordsDownloadRequest.step.submitRequest">リクエスト送信</span>
            </button>
          </nav>

          <!-- Step Content -->
          <div class="step-content">
            <!-- Step 1: 抽出条件 -->
            @if (currentStepIndex === 0) {
              <div class="step-content__header">
                <mat-icon class="step-content__icon">tune</mat-icon>
                <h2 class="step-content__title" i18n="@@adminSection.createRecordsDownloadRequest.step.specifyConditions">
                  抽出条件を指定してください
                </h2>
              </div>

              <form [formGroup]="createConditionFormGroup" class="step-content__form">
                <!-- 期間 -->
                <div class="form-group">
                  <label class="form-group__label" i18n="@@adminSection.createRecordsDownloadRequest.label.period">期間</label>
                  <div class="form-group__row form-group__row--datepicker">
                    <mat-form-field appearance="outline" class="date-field">
                      <mat-label i18n="@@adminSection.createRecordsDownloadRequest.label.fromDate">開始</mat-label>
                      <input matInput
                             [matDatepicker]="fromPicker"
                             formControlName="fromDate"
                             (dateChange)="conditionChanged()" />
                      <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                      <mat-datepicker #fromPicker></mat-datepicker>
                    </mat-form-field>
                    <span class="form-group__separator">〜</span>
                    <mat-form-field appearance="outline" class="date-field">
                      <mat-label i18n="@@adminSection.createRecordsDownloadRequest.label.toDate">終了</mat-label>
                      <input matInput
                             [matDatepicker]="toPicker"
                             formControlName="toDate"
                             (dateChange)="conditionChanged()" />
                      <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                      <mat-datepicker #toPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

                <!-- データ種別 -->
                <div class="form-group">
                  <label class="form-group__label" i18n="@@adminSection.createRecordsDownloadRequest.label.dataType">データ種別</label>
                  <div class="form-group__checkboxes">
                    @for (type of fileTypes; track type.value) {
                      <label class="checkbox-item">
                        <input type="checkbox" [formControlName]="type.value" (change)="conditionChanged()" />
                        <span class="checkbox-item__box">
                          <mat-icon class="checkbox-item__check">check</mat-icon>
                        </span>
                        <span class="checkbox-item__label">{{ type.display }}</span>
                      </label>
                    }
                  </div>
                </div>

                <div class="form-divider"></div>

                <!-- ユーザー -->
                <div class="form-group">
                  <label class="form-group__label" i18n="@@adminSection.createRecordsDownloadRequest.label.user">ユーザー</label>
                  <div class="form-group__radios">
                    <label class="radio-item">
                      <input type="radio" formControlName="allOrSelectedUsers" value="all" (change)="onAllUserSelected()" />
                      <span class="radio-item__circle"></span>
                      <span class="radio-item__label" i18n="@@adminSection.createRecordsDownloadRequest.label.allUsers">すべてのユーザー</span>
                    </label>
                    <label class="radio-item">
                      <input type="radio" formControlName="allOrSelectedUsers" value="selected" (change)="isUserListExpanded.set(true)" />
                      <span class="radio-item__circle"></span>
                      <span class="radio-item__label" i18n="@@adminSection.createRecordsDownloadRequest.label.specificUsers">特定のユーザー</span>
                    </label>
                  </div>

                  <!-- User Select Panel -->
                  @if (createConditionFormGroup.get('allOrSelectedUsers').value === 'selected') {
                    <div class="user-panel">
                      <!-- Search -->
                      <div class="user-panel__search">
                        <mat-icon>search</mat-icon>
                        <input type="text"
                               [formControl]="userSearchControl"
                               placeholder="ユーザー名で検索"
                               i18n-placeholder="@@adminSection.createRecordsDownloadRequest.placeholder.searchUser" />
                        @if (userSearchControl.value) {
                          <button type="button" class="user-panel__clear" (click)="userSearchControl.setValue('')">
                            <mat-icon>close</mat-icon>
                          </button>
                        }
                      </div>

                      <!-- Actions -->
                      <div class="user-panel__actions">
                        <button type="button" class="user-panel__action-btn" (click)="selectAllUsers()">
                          <mat-icon>check_box</mat-icon>
                          <span i18n="@@adminSection.createRecordsDownloadRequest.button.selectAll">すべて選択</span>
                        </button>
                        <button type="button" class="user-panel__action-btn" (click)="clearAllUsers()">
                          <mat-icon>check_box_outline_blank</mat-icon>
                          <span i18n="@@adminSection.createRecordsDownloadRequest.button.clearAll">すべて解除</span>
                        </button>
                      </div>

                      <!-- List -->
                      <div class="user-panel__list">
                        @if (isLoadingUsers()) {
                          @for (i of [1, 2, 3, 4, 5]; track i) {
                            <div class="user-panel__skeleton">
                              <div class="skeleton skeleton--checkbox"></div>
                              <div class="skeleton skeleton--name"></div>
                            </div>
                          }
                        } @else {
                          @for (user of filteredUsers(); track user.userId) {
                            <label class="user-panel__item">
                              <input type="checkbox"
                                     [checked]="isUserSelected(user.userId)"
                                     (change)="toggleUserSelection(user.userId)" />
                              <span class="checkbox-item__box">
                                <mat-icon class="checkbox-item__check">check</mat-icon>
                              </span>
                              <span class="user-panel__name">{{ user.name }}</span>
                              @if (user.status === 'NOT AVAILABLE') {
                                <span class="user-panel__status" i18n="@@adminSection.createRecordsDownloadRequest.label.notAvailable">利用不可</span>
                              }
                            </label>
                          } @empty {
                            <div class="user-panel__empty">
                              <mat-icon>search_off</mat-icon>
                              <span i18n="@@adminSection.createRecordsDownloadRequest.message.noUsersFound">該当するユーザーが見つかりません</span>
                            </div>
                          }
                        }
                      </div>

                      <!-- Footer -->
                      <div class="user-panel__footer">
                        <span i18n="@@adminSection.createRecordsDownloadRequest.label.selectedCount">
                          {{ (selectedUserIds.value || []).length }} / {{ users.length }} 件選択中
                        </span>
                      </div>
                    </div>
                  }
                </div>

                <!-- Actions -->
                <div class="step-actions">
                  <button mat-flat-button
                          type="button"
                          color="primary"
                          (click)="nextStep()">
                    <span i18n="@@adminSection.createRecordsDownloadRequest.button.next">次へ</span>
                    <mat-icon>arrow_forward</mat-icon>
                  </button>
                </div>
              </form>
            }

            <!-- Step 2: サイズ見積もり -->
            @if (currentStepIndex === 1) {
              <div class="step-content__header">
                <mat-icon class="step-content__icon">analytics</mat-icon>
                <h2 class="step-content__title" i18n="@@adminSection.createRecordsDownloadRequest.title.sizeEstimation">
                  ファイルサイズ見積もり確認
                </h2>
              </div>

              <div class="estimation-card">
                @if (sizeEstimation() !== null) {
                  <p class="estimation-card__intro" i18n="@@adminSection.createRecordsDownloadRequest.message.sizeEstimationIntro">
                    条件に合致するファイルのトータルサイズは以下のとおりです。
                  </p>
                  <div class="estimation-card__details">
                    <div class="estimation-card__item">
                      <span class="estimation-card__label" i18n="@@adminSection.createRecordsDownloadRequest.label.fileCount">ファイル数</span>
                      <span class="estimation-card__value">{{ sizeEstimation().numberOfRecords }}</span>
                    </div>
                    <div class="estimation-card__item">
                      <span class="estimation-card__label" i18n="@@adminSection.createRecordsDownloadRequest.label.totalSize">トータルサイズ</span>
                      <span class="estimation-card__value">{{ sizeEstimation().totalSizeFormatted }}</span>
                    </div>
                  </div>
                } @else {
                  <div class="estimation-card__loading">
                    <div class="estimation-progress">
                      <div class="estimation-progress__bar"></div>
                    </div>
                    <div class="estimation-loading__status">
                      <mat-icon class="estimation-loading__icon">hourglass_empty</mat-icon>
                      <div class="estimation-loading__text">
                        <span class="estimation-loading__title" i18n="@@adminSection.createRecordsDownloadRequest.message.calculating">
                          ファイルサイズを計算中
                        </span>
                        <span class="estimation-loading__subtitle">
                          @if (estimationElapsedSeconds() > 0) {
                            <span i18n="@@adminSection.createRecordsDownloadRequest.message.elapsedTime">
                              経過時間: {{ estimationElapsedSeconds() }}秒
                            </span>
                          } @else {
                            <span i18n="@@adminSection.createRecordsDownloadRequest.message.pleaseWait">
                              しばらくお待ちください...
                            </span>
                          }
                        </span>
                      </div>
                    </div>
                    <p class="estimation-loading__hint" i18n="@@adminSection.createRecordsDownloadRequest.message.estimationHint">
                      データ量によって処理時間が変わります
                    </p>
                  </div>
                }
              </div>

              <div class="step-actions">
                <button mat-stroked-button
                        type="button"
                        (click)="prevStep()">
                  <mat-icon>arrow_back</mat-icon>
                  <span i18n="@@adminSection.createRecordsDownloadRequest.button.back">戻る</span>
                </button>
                <button mat-flat-button
                        type="button"
                        color="primary"
                        [disabled]="!sizeEstimation()"
                        (click)="nextStep()">
                  <span i18n="@@adminSection.createRecordsDownloadRequest.button.nextEstimation">次へ</span>
                  <mat-icon>arrow_forward</mat-icon>
                </button>
              </div>
            }

            <!-- Step 3: リクエスト送信 -->
            @if (currentStepIndex === 2) {
              <div class="step-content__header">
                <mat-icon class="step-content__icon">cloud_download</mat-icon>
                <h2 class="step-content__title" i18n="@@adminSection.createRecordsDownloadRequest.title.downloadRequest">
                  ダウンロードリクエスト
                </h2>
              </div>

              <div class="submit-card">
                <mat-icon class="submit-card__icon">send</mat-icon>
                <p class="submit-card__text" i18n="@@adminSection.createRecordsDownloadRequest.message.submitInstruction">
                  下記ボタンをクリックするとダウンロードのリクエストがサーバに提出されます
                </p>
              </div>

              <div class="step-actions">
                <button mat-stroked-button
                        type="button"
                        (click)="prevStep()">
                  <mat-icon>arrow_back</mat-icon>
                  <span i18n="@@adminSection.createRecordsDownloadRequest.button.backToEstimation">戻る</span>
                </button>
                <button mat-flat-button
                        type="button"
                        color="primary"
                        [disabled]="!createConditionFormGroup.valid || !sizeEstimation() || isSending()"
                        (click)="update()">
                  @if (isSending()) {
                    <mat-spinner diameter="18"></mat-spinner>
                  } @else {
                    <mat-icon>send</mat-icon>
                  }
                  <span i18n="@@adminSection.createRecordsDownloadRequest.button.submitRequest">リクエスト提出</span>
                </button>
              </div>
            }
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
